import React from 'react';
import { EventCard } from '../EventCard/EventCard';
import { Event } from '../../../domain/entities/Event';
import './Sections.css';

interface EventsSectionProps {
  events: Event[];
}

export const EventsSection: React.FC<EventsSectionProps> = ({ events }) => {
  return (
    <section className="content-section">
      <h2 className="section-title">Próximos Eventos</h2>
      <p className="section-subtitle">
        Descubra os eventos especiais que estão por vir na Casa do Pandeiro
      </p>
      
      {events.length > 0 ? (
        <div className="events-container">
          {events.map((event, index) => (
            <EventCard key={index} event={event} />
          ))}
        </div>
      ) : (
        <div className="no-events">
          <p>Nenhum evento programado</p>
          <p>Fique atento às nossas redes sociais para novidades!</p>
        </div>
      )}
    </section>
  );
}; 